module.exports = __webpack_public_path__ + "assets/baa5b561c98df95528ec3ce96d60c0ff.png";